import { createContext, FC, useState } from 'react';
import { timeType } from 'src/utils/constants';
import { getDefaultTimeRangeValue } from 'src/utils/helpers';

type timeRangeContext = {
  selectedTimeRange: timeType;
  setTimeRange: (range: timeType) => void;
};
export const TimeRangeContext = createContext<timeRangeContext>(
  {} as timeRangeContext
);

export const TimeRangeProvider: FC = ({ children }) => {
  const [selectedTimeRange, setSelectedTimeRange] = useState<timeType>(
    getDefaultTimeRangeValue()
  );

  const setTimeRange = (range: timeType) => {
    localStorage.setItem('defaultTimeRange', `${range}`);
    setSelectedTimeRange(range);
  };

  return (
    <TimeRangeContext.Provider
      value={{
        selectedTimeRange,
        setTimeRange
      }}
    >
      {children}
    </TimeRangeContext.Provider>
  );
};
